export default "__VITE_ASSET__596054ef__"